import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EToggleSearchingModalActionType, TToggleSearchingModal } from './types';
import { ISettings } from '../../../types/settings';

export const toggleSearchingModal: (value?: ISettings['isSearchingModalOpened']) => TToggleSearchingModal =
  actionGenerator<EToggleSearchingModalActionType.Set, ISettings['isSearchingModalOpened']>(
    EToggleSearchingModalActionType.Set,
  );
